'use strict';
/**
 * Validates a password. This requires that the password:
 * 'upper': Contains at least upper case character
 * 'lower':Contains at least lower case character
 * 'digit': Contains at least one digit
 * 'length': Eight characters or more
 * If any of these are untrue, it will set the validity of the field to false. The value will still be passed
 * to model, even if it's invalid.
 */

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

angular.module('msCore').directive('msValidatePassword', [function () {
  return {
    replace: false,
    restrict: 'A',
    require: 'ngModel',
    scope: {
      passStrength: '=?',
      msMatchValue: '<?',
      extraDictionary: '<?'
    },
    link: function link(scope, iElement, iAttrs, ngModel) {

      ngModel.$parsers.unshift(function (value) {
        if (value) {
          ngModel.$setValidity('length', value.length > 11);
          ngModel.$setValidity('upper', value.toLowerCase() !== value);
          ngModel.$setValidity('lower', value.toUpperCase() !== value);
          ngModel.$setValidity('digit', value.match(/\d+/g) !== null);
          setStrengthValidity(value);

          if (scope.msMatchValue) {
            ngModel.$setValidity('match', value === scope.msMatchValue);
          }
        }
        ngModel.$setValidity('duplicate', true);
        return value;
      });

      function setStrengthValidity(value) {
        if (window && window.zxcvbn) {
          // validate password strength with zxcvbn library
          var zxcvbn = window.zxcvbn;

          var extraDictionary = setExtraDictionary(scope.extraDictionary);
          var customDictionary = ['teladoc', 'mystrength'];

          var zxcvbnStrength = zxcvbn(value, [].concat(_toConsumableArray(extraDictionary), customDictionary));

          ngModel.$setValidity('toweak', true);

          var passStrengthMaping = {
            '0': 'VERY_WEAK',
            '1': 'WEAK',
            '2': 'REASONABLE',
            '3': 'STRONG',
            '4': 'VERY_STRONG'
          };
          if (zxcvbnStrength.score < 2) {
            ngModel.$setValidity('toweak', false);
          }
          scope.passStrength = passStrengthMaping[zxcvbnStrength.score];
        } else {
          // fallback validation 
          var passStrengthCode = 0;
          if (value.length > 5) {
            passStrengthCode = passStrengthCode + 10;

            if (value.length > 11) {
              passStrengthCode = passStrengthCode + 10;

              if (value.toLowerCase() !== value) {
                passStrengthCode = passStrengthCode + 20;
              }
              if (value.toUpperCase() !== value) {
                passStrengthCode = passStrengthCode + 20;
              }
              if (value.match(/\d+/g) !== null) {
                passStrengthCode = passStrengthCode + 20;
              }
              if (value.length > 15) {
                passStrengthCode = passStrengthCode + 10;
                if (value.length > 24) {
                  passStrengthCode = passStrengthCode + 10;
                }
              }
            }
          }

          var _passStrengthMaping = {
            '10': 'VERY_WEAK',
            '20': 'VERY_WEAK',
            '30': 'WEAK',
            '40': 'WEAK',
            '50': 'REASONABLE',
            '60': 'REASONABLE',
            '70': 'REASONABLE',
            '80': 'STRONG',
            '90': 'STRONG',
            '100': 'VERY_STRONG'
          };

          scope.passStrength = _passStrengthMaping[passStrengthCode];
        }
      }

      function setExtraDictionary() {
        if (angular.isDefined(scope.extraDictionary)) {
          if (angular.isArray(scope.extraDictionary)) {
            return scope.extraDictionary;
          } else if (isForm(scope.extraDictionary)) {
            return parseFormValues(scope.extraDictionary);
          }
        }
        return [];
      }

      function parseFormValues(form) {
        var extrasArray = [];
        // Doesn't start with "$" or "__"
        var validPropertyRegex = new RegExp('^(?!\\$|__)');
        for (var prop in form) {
          // Property's containing the string "password" should also be ignored
          if (validPropertyRegex.test(prop) && form[prop].hasOwnProperty('$viewValue') && prop.toLowerCase().indexOf('password') === -1 && form[prop].$viewValue) {
            extrasArray.push(form[prop].$viewValue);
          }
        }
        return extrasArray;
      }

      function isForm(value) {
        try {
          return Object.getPrototypeOf(value).constructor.name === 'FormController' || angular.isDefined(value.$setValidity);
        } catch (error) {
          return false;
        }
      }
    }
  };
}]);